import React, { useContext, useState, useEffect } from 'react'
import { AllStarContext } from '../../../../Context'
import {
  ChallengeItem,
  UnleashedPlayer,
  unleashedPlayersList,
  getParticipants,
  getUnleashedParticipants,
} from './skillsHelper'
import { PlayerItem } from '../AllStarGameCon/Rosters/PlayerItem'
import { Desc, Head2 } from '../../../../Components/Typography/Text.styles'
import { PlayerDataGQL } from '../../../../Api'
import { ChallengeRules } from './ChallengeRules'
import { colors } from '../../../../Components/consts'
import { UnleashedPlayerItem } from '../AllStarGameCon/Rosters/UnleashedPlayerItem'
import { SkillsParticipantsCon } from '../../styles'
import { PLL_CONFERENCES } from '../../../../Constants/season'

type ChallengeItemProps = {
  challenge: ChallengeItem
}

export const DerbyChallengeItemSection: React.FC<ChallengeItemProps> = ({
  challenge,
}) => {
  const { allStarEvent } = useContext(AllStarContext)!
  const [teamOneParticipants, setTeamOneParticipants] = useState<{
    pll: PlayerDataGQL[]
    unleashed: UnleashedPlayer[]
  }>({ pll: [], unleashed: [] })
  const [teamTwoParticipants, setTeamTwoParticipants] = useState<{
    pll: PlayerDataGQL[]
    unleashed: UnleashedPlayer[]
  }>({ pll: [], unleashed: [] })

  useEffect(() => {
    bucketParticipants()
  }, [allStarEvent])

  const bucketParticipants = () => {
    let awayPlayers = allStarEvent?.awayTeam?.players || []
    let homePlayers = allStarEvent?.homeTeam?.players || []
    let fullList = [...awayPlayers, ...homePlayers]
    if (fullList.length > 0) {
      const pList = getParticipants(challenge.slug, fullList)
      if (pList.length > 0) {
        const firstPLLTeam = pList.filter(
          (pl) => pl.currentTeam.conference === 'eastern'
        )
        const uListOne = getUnleashedParticipants(
          challenge.slug,
          unleashedPlayersList
        ).filter((ul) => ul.currentTeam.conference === 'eastern')
        setTeamOneParticipants({ pll: firstPLLTeam, unleashed: uListOne })

        const secondPLLTeam = pList.filter(
          (pl) => pl.currentTeam.conference === 'western'
        )
        const uListTwo = getUnleashedParticipants(
          challenge.slug,
          unleashedPlayersList
        ).filter((ul) => ul.currentTeam.conference === 'western')

        setTeamTwoParticipants({ pll: secondPLLTeam, unleashed: uListTwo })
      }
    }
  }

  return (
    <>
      <Desc textColor={colors.gray.gray20} vertMargins={0}>
        {challenge.desc}
      </Desc>
      <Head2 textColor={colors.gray.gray20} vertMargins={4}>
        {'Participants'}
      </Head2>
      <SkillsParticipantsCon>
        <Desc textColor={colors.gray.gray20} vertMargins={0}>
          {PLL_CONFERENCES.EASTERN.toUpperCase()}
        </Desc>
        <div className="skillsParticipants">
          {teamOneParticipants.pll.length > 0 &&
            teamOneParticipants.pll.map((pl) => (
              <PlayerItem key={pl.slug} playerInfo={pl} side={'right'} />
            ))}
          {teamOneParticipants.unleashed.length > 0 &&
            teamOneParticipants.unleashed.map((pl) => (
              <UnleashedPlayerItem key={pl.slug} playerInfo={pl} side={'right'} />
            ))}
          {teamOneParticipants.pll.length === 0 && (
            <Desc justify="center" textColor={colors.gray.gray20}>
              Participants will be announced after All-Stars are selected
            </Desc>
          )}
        </div>
        <Desc textColor={colors.gray.gray20} vertMargins={0}>
          {PLL_CONFERENCES.WESTERN.toUpperCase()}
        </Desc>
        <div className="skillsParticipants">
          {teamTwoParticipants.pll.length > 0 &&
            teamTwoParticipants.pll.map((pl) => (
              <PlayerItem key={pl.slug} playerInfo={pl} side={'right'} />
            ))}
          {teamTwoParticipants.unleashed.length > 0 &&
            teamTwoParticipants.unleashed.map((pl) => (
              <UnleashedPlayerItem key={pl.slug} playerInfo={pl} side={'right'} />
            ))}
          {teamTwoParticipants.pll.length === 0 && (
            <Desc justify="center" textColor={colors.gray.gray20}>
              Participants will be announced after All-Stars are selected
            </Desc>
          )}
        </div>
      </SkillsParticipantsCon>
      <ChallengeRules challengeName={challenge.slug} />
    </>
  )
}
